import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useIsDesktop } from '../../hooks/useIsDesktop';
import ProjectListPage from '../../pages/ProjectListPage';
import ProjectDetailPage from '../../pages/ProjectDetailPage';
import ProjectFormPage from '../../pages/ProjectFormPage';
import { DesktopHome } from './DesktopHome';
import { ProjectWorkspace } from './ProjectWorkspace';

/**
 * Route-level switches between the phone screens and their desktop
 * counterparts. The phone pages are mounted untouched below `lg`; above it
 * the desktop workspace takes over the same URLs, so links and bookmarks
 * work identically on both.
 */
export const HomeRoute: React.FC = () => (useIsDesktop() ? <DesktopHome /> : <ProjectListPage />);

export const ProjectRoute: React.FC = () => (useIsDesktop() ? <ProjectWorkspace mode="edit" /> : <ProjectDetailPage />);

export const NewProjectRoute: React.FC = () => (useIsDesktop() ? <ProjectWorkspace mode="create" /> : <ProjectFormPage />);

/** On desktop the workspace already edits in place, so /edit folds into it. */
export const EditProjectRoute: React.FC = () => {
  const isDesktop = useIsDesktop();
  const { projectId } = useParams<{ projectId: string }>();
  if (isDesktop) return <Navigate to={`/projects/${projectId}`} replace />;
  return <ProjectFormPage />;
};
